<template>
  <div class="page-wrapper">
    <Header :active-nav="activeNav" @nav-click="scrollToSection" />

    <div class="page-content">
      <section class="page-title-section">
        <div class="page-title-container">
          <div
            class="page-title-icon"
            data-aos="zoom-in"
            data-aos-duration="800"
          >
            <i class="fas fa-building"></i>
          </div>
          <h1 class="page-title" data-aos="fade-up" data-aos-duration="800">
            公司介绍
          </h1>
          <p class="page-subtitle" data-aos="fade-up" data-aos-delay="200">
            Company Profile
          </p>
          <div
            class="page-title-line"
            data-aos="fade-up"
            data-aos-delay="400"
          ></div>
        </div>
      </section>

      <main class="company-detail">
        <section class="group-overview" data-aos="fade-up">
          <div class="group-header">
            <div class="group-badge">
              <i class="fas fa-landmark"></i>
            </div>
            <div class="group-title">
              <h2>宁波东方联信实业发展有限公司</h2>
              <p class="group-subtitle">集团总部：实业基石，多元发展</p>
            </div>
          </div>

          <div class="group-content">
            <div class="group-intro">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                宁波东方联信实业发展有限公司成立于2008年，注册资本9亿元，总部位于宁波。
                集团以实业发展为纽带，聚焦综合商贸与制造业，业务涵盖机械制造、食品加工、
                进出口贸易、信息技术、新能源等领域。
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                截至2023年底，集团总资产约60亿元，年营业收入超50亿元，
                旗下拥有全资及控股公司17余家。
              </p>
            </div>

            <div class="group-stats">
              <div class="stat-card" data-aos="fade-up" data-aos-delay="100">
                <div class="stat-icon">
                  <i class="fas fa-chart-line"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-number">60<span>亿</span></div>
                  <div class="stat-label">总资产规模</div>
                </div>
              </div>
              <div class="stat-card" data-aos="fade-up" data-aos-delay="200">
                <div class="stat-icon">
                  <i class="fas fa-money-bill-wave"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-number">50<span>亿</span></div>
                  <div class="stat-label">年营业收入</div>
                </div>
              </div>
              <div class="stat-card" data-aos="fade-up" data-aos-delay="300">
                <div class="stat-icon">
                  <i class="fas fa-building"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-number">17<span>+</span></div>
                  <div class="stat-label">全资及控股公司</div>
                </div>
              </div>
              <div class="stat-card" data-aos="fade-up" data-aos-delay="400">
                <div class="stat-icon">
                  <i class="fas fa-calendar-alt"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-number">2008</div>
                  <div class="stat-label">成立年份</div>
                </div>
              </div>
            </div>

            <div class="group-business-scope">
              <h3>业务范围</h3>
              <div class="business-tags">
                <span class="business-tag">机械制造</span>
                <span class="business-tag">食品加工</span>
                <span class="business-tag">进出口贸易</span>
                <span class="business-tag">信息技术</span>
                <span class="business-tag">新能源</span>
              </div>
            </div>
          </div>
        </section>

        <section class="food-business-section">
          <div class="section-intro" data-aos="fade-up">
            <h2>食品业务板块</h2>
            <p class="section-subtitle">Food Business Division</p>
            <p class="section-description">
              集团以"宁波东方联信"为实业基石，在食品领域形成"贸易+生产"双轮驱动格局，
              通过"浙江丰沃"与"浙江太丰"两大公司协同发展，构建完整的食品产业链。
            </p>
          </div>

          <div class="business-layout">
            <div class="business-column trade-column" data-aos="fade-right">
              <div class="company-card">
                <div class="company-header">
                  <div
                    class="company-logo"
                    style="
                      background: linear-gradient(135deg, #9e1317, #b81c22);
                    "
                  >
                    <i class="fas fa-store"></i>
                  </div>
                  <div class="company-title">
                    <h3>浙江丰沃国际贸易有限公司</h3>
                    <p class="company-subtitle">
                      食品贸易板块：老字号焕新，引领市场
                    </p>
                  </div>
                </div>

                <div class="company-content">
                  <div class="company-intro">
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      浙江丰沃国际贸易有限公司作为集团重要成员，秉承集团实业发展的核心战略，
                      融汇传统匠心与现代创新，致力于成为食品产业的引领者。
                      公司以深厚的行业积淀为基石，通过多品牌运营与全产业链布局，
                      为消费者与合作伙伴持续提供健康、优质的产品。
                    </p>
                  </div>

                  <div class="brand-highlight">
                    <div class="brand-badge">
                      <i class="fas fa-award"></i>
                      <span>浙江老字号</span>
                    </div>
                    <h4>核心品牌——"太丰"</h4>
                    <p class="brand-desc">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      历经近百年历史传承，推陈出新。太丰重视自主研发，建立了自有工厂、
                      实验室和研发团队，通过了ISO22000、HACCP体系等认证，获得多项发明专利。
                    </p>
                  </div>

                  <div class="achievement-stats">
                    <div class="achievement-item">
                      <div class="achievement-icon">
                        <i class="fas fa-trophy"></i>
                      </div>
                      <div class="achievement-content">
                        <div class="achievement-value">TOP 1</div>
                        <div class="achievement-label">
                          抖音电商牛肉干排行榜
                        </div>
                      </div>
                    </div>
                    <!-- <div class="achievement-item">
                      <div class="achievement-icon">
                        <i class="fas fa-chart-bar"></i>
                      </div>
                      <div class="achievement-content">
                        <div class="achievement-value">2<span>亿</span></div>
                        <div class="achievement-label">2023年销售额</div>
                      </div>
                    </div> -->
                  </div>

                  <div class="marketing-strategy">
                    <h5>营销策略</h5>
                    <div class="strategy-tags">
                      <span class="strategy-tag">达人带货</span>
                      <span class="strategy-tag">抖音直播</span>
                      <span class="strategy-tag">多元化营销</span>
                      <span class="strategy-tag">休闲食品转型</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="business-column production-column" data-aos="fade-left">
              <div class="company-card">
                <div class="company-header">
                  <div
                    class="company-logo"
                    style="
                      background: linear-gradient(135deg, #9e1317, #b81c22);
                    "
                  >
                    <i class="fas fa-industry"></i>
                  </div>
                  <div class="company-title">
                    <h3>浙江太丰食品科技有限公司</h3>
                    <p class="company-subtitle">
                      食品加工板块：布局延伸，强化优势
                    </p>
                  </div>
                </div>

                <div class="company-content">
                  <div class="company-intro">
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      为深化食品产业链布局，集团于2023年成立浙江太丰食品科技有限公司，
                      在舟山新建生产基地。该项目充分发挥舟山港口优势与集团海外原料资源，
                      将进一步夯实太丰品牌的研发、生产与供应链实力。
                    </p>
                  </div>

                  <div class="project-highlight">
                    <div class="project-badge">
                      <i class="fas fa-calendar-plus"></i>
                      <span>2023年成立</span>
                    </div>
                    <h4>舟山生产基地项目</h4>

                    <div class="project-details">
                      <div class="detail-item">
                        <div class="detail-icon">
                          <i class="fas fa-calendar-alt"></i>
                        </div>
                        <div class="detail-content">
                          <div class="detail-label">动工时间</div>
                          <div class="detail-value">2024年</div>
                        </div>
                      </div>

                      <div class="detail-item">
                        <div class="detail-icon">
                          <i class="fas fa-map-marker-alt"></i>
                        </div>
                        <div class="detail-content">
                          <div class="detail-label">项目位置</div>
                          <div class="detail-value">浙江舟山</div>
                        </div>
                      </div>

                      <div class="detail-item">
                        <div class="detail-icon">
                          <i class="fas fa-expand-arrows-alt"></i>
                        </div>
                        <div class="detail-content">
                          <div class="detail-label">占地面积</div>
                          <div class="detail-value">4万㎡</div>
                        </div>
                      </div>

                      <div class="detail-item">
                        <div class="detail-icon">
                          <i class="fas fa-building"></i>
                        </div>
                        <div class="detail-content">
                          <div class="detail-label">建筑面积</div>
                          <div class="detail-value">约7万㎡</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="advantage-analysis">
                    <h5>项目优势</h5>
                    <ul class="advantage-list">
                      <li>
                        <i class="fas fa-check-circle"></i>
                        <span>依托舟山深水港口，物流成本优势显著</span>
                      </li>
                      <li>
                        <i class="fas fa-check-circle"></i>
                        <span>整合集团海外原料资源，供应链稳定</span>
                      </li>
                      <li>
                        <i class="fas fa-check-circle"></i>
                        <span>强化自主研发能力，提升产品竞争力</span>
                      </li>
                      <li>
                        <i class="fas fa-check-circle"></i>
                        <span>完善生产体系，保障产品质量</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="business-areas" data-aos="fade-up">
          <div class="section-header">
            <h2>食品业务核心版图</h2>
            <p class="section-subtitle">Core Business Layout</p>
          </div>

          <div class="business-grid">
            <div
              class="business-card"
              v-for="(business, index) in businessAreas"
              :key="index"
              data-aos="zoom-in"
              :data-aos-delay="index * 100"
              @mouseenter="hoverBusiness = index"
              @mouseleave="hoverBusiness = -1"
              :class="{ hovered: hoverBusiness === index }"
            >
              <div class="business-icon-container">
                <div
                  class="business-icon"
                  :style="{
                    background: `linear-gradient(135deg, rgba(158, 19, 23, 0.3), rgba(158, 19, 23, 0.15))`,
                    borderColor: '#9e1317',
                  }"
                >
                  <i :class="business.icon"></i>
                </div>
              </div>
              <h3>{{ business.title }}</h3>
              <p class="business-subtitle">{{ business.subtitle }}</p>
              <ul class="business-details">
                <li
                  v-for="(item, itemIndex) in business.items"
                  :key="itemIndex"
                >
                  <i class="fas fa-check"></i>
                  <span>{{ item }}</span>
                </li>
              </ul>
              <div class="business-tags">
                <span
                  class="business-tag"
                  v-for="(tag, tagIndex) in business.tags"
                  :key="tagIndex"
                >
                  {{ tag }}
                </span>
              </div>
            </div>
          </div>
        </section>

        <section class="industry-advantages" data-aos="fade-up">
          <div class="section-header">
            <h2>产业优势</h2>
            <p class="section-subtitle">Industry Advantages</p>
          </div>

          <div class="advantages-grid">
            <div
              class="advantage-card"
              v-for="(advantage, index) in industryAdvantages"
              :key="index"
              data-aos="fade-up"
              :data-aos-delay="index * 100"
            >
              <div
                class="advantage-icon"
                :style="{
                  background: `linear-gradient(135deg, rgba(158, 19, 23, 0.4), rgba(158, 19, 23, 0.2))`,
                }"
              >
                <i :class="advantage.icon"></i>
              </div>
              <h3>{{ advantage.title }}</h3>
              <p>
                {{ advantage.description }}
              </p>
              <div class="advantage-stats">
                <div
                  class="advantage-stat"
                  v-for="(stat, statIndex) in advantage.stats"
                  :key="statIndex"
                >
                  <div class="stat-value">{{ stat.value }}</div>
                  <div class="stat-label">{{ stat.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="future-vision" data-aos="fade-up">
          <div class="vision-container">
            <div class="vision-icon">
              <i class="fas fa-rocket"></i>
              <div class="vision-glow"></div>
            </div>
            <div class="vision-content">
              <h2>未来愿景</h2>
              <p>
                未来，丰沃国际将持续聚焦于品牌价值、产销一体与供应链品效的多重提升，
                立志成为值得信赖的健康食品提供者。
              </p>
              <div class="vision-roadmap">
                <div
                  class="roadmap-item"
                  v-for="(item, index) in futureRoadmap"
                  :key="index"
                >
                  <div class="roadmap-number">0{{ index + 1 }}</div>
                  <div class="roadmap-content">
                    <h4>{{ item.title }}</h4>
                    <p>{{ item.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

    <Footer @scroll-to="scrollToSection" @show-product="showProduct" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Company",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      activeNav: "company",
      hoverBusiness: -1,
      businessAreas: [
        {
          title: "品牌食品领域",
          subtitle: "「太丰」系列经典美食",
          icon: "fas fa-utensils",
          items: [
            '旗下核心品牌"太丰"，深耕中华美食文化',
            "成功打造古法卤牛肉干、芝香牛肉干系列",
            "在休闲零食赛道树立品牌标杆",
            "以匠心工艺守护传统风味",
          ],
          tags: ["品牌建设", "文化传承", "品质标杆"],
        },
        {
          title: "肉制品加工",
          subtitle: "全链条品质把控",
          icon: "fas fa-industry",
          items: [
            "宁波及舟山自有工厂",
            "生产到销售全链条把控",
            "源头可溯、品质可控",
            "专业的OEM/ODM代加工服务",
          ],
          tags: ["自主生产", "质量管控", "代工服务"],
        },
        {
          title: "全球原料供应",
          subtitle: "垂直整合产业链",
          icon: "fas fa-globe-americas",
          items: [
            "战略性开拓腰果产业链",
            "非洲直采渠道，国内加工",
            '"从源头到成品"垂直整合',
            "提供高性价比优质原料",
          ],
          tags: ["全球采购", "产业链整合", "品质保证"],
        },
      ],
      industryAdvantages: [
        {
          title: "实业基础",
          icon: "fas fa-industry",
          description: "依托集团实业发展优势，拥有强大的产业支撑",
          stats: [
            { value: "9亿", label: "注册资本" },
            { value: "17+", label: "控股公司" },
          ],
        },
        {
          title: "产业链完整",
          icon: "fas fa-link",
          description: "从原料采购到生产销售的完整产业链布局",
          stats: [
            { value: "垂直", label: "整合模式" },
            { value: "全链", label: "品质把控" },
          ],
        },
        {
          title: "技术创新",
          icon: "fas fa-lightbulb",
          description: "传统工艺与现代技术的完美结合",
          stats: [
            { value: "匠心", label: "工艺传承" },
            { value: "创新", label: "技术应用" },
          ],
        },
      ],
      futureRoadmap: [
        {
          title: "品牌价值提升",
          description: '持续打造"太丰"品牌影响力，深化品牌文化内涵',
        },
        {
          title: "产销一体深化",
          description: "优化生产销售体系，实现全链条高效协同",
        },
        {
          title: "供应链优化",
          description: "强化全球原料供应能力，提升产品品质稳定性",
        },
      ],
    };
  },
  mounted() {
    this.initAnimations();
  },
  methods: {
    initAnimations() {
      if (window.AOS) {
        AOS.init({
          duration: 800,
          once: true,
          offset: 100,
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    scrollToSection(sectionId) {
      this.$router.push({ name: "Home", hash: `#${sectionId}` });
    },
    showProduct(id) {
      this.$router.push({ name: "ProductDetail", params: { id } });
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.page-content {
  flex: 1;
}

.page-title-section {
  background: linear-gradient(
    135deg,
    rgba(158, 19, 23, 0.08),
    rgba(158, 19, 23, 0.02)
  );
  padding: 150px 50px 100px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.page-title-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(to right, #9e1317, #b81c22);
}

.page-title-container {
  position: relative;
  z-index: 1;
}

.page-title-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  font-size: 3rem;
  color: white;
  box-shadow: 0 15px 35px rgba(158, 19, 23, 0.25);
}

.page-title {
  font-size: 3.5rem;
  font-weight: 800;
  color: #222222;
  margin-bottom: 15px;
}

.page-subtitle {
  font-size: 1.2rem;
  color: #666666;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 30px;
}

.page-title-line {
  width: 100px;
  height: 3px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  margin: 0 auto;
  border-radius: 2px;
}

.company-detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 50px;
  background: #ffffff;
}

.group-overview {
  background: rgba(158, 19, 23, 0.04);
  border-radius: 25px;
  padding: 50px;
  margin-bottom: 80px;
  border: 2px solid rgba(158, 19, 23, 0.15);
  position: relative;
  overflow: hidden;
}

.group-overview::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(to bottom, #9e1317, #b81c22);
}

.group-header {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-bottom: 35px;
}

.group-badge {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  flex-shrink: 0;
  box-shadow: 0 10px 25px rgba(158, 19, 23, 0.2);
}

.group-title h2 {
  font-size: 2.2rem;
  color: #222222;
  margin-bottom: 10px;
}

.group-subtitle {
  color: #9e1317;
  font-size: 1.2rem;
  font-weight: 600;
}

.group-intro {
  margin-bottom: 40px;
}

.group-intro p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444444;
  margin-bottom: 20px;
  text-align: justify;
}

.group-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: white;
  border-radius: 15px;
  padding: 25px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid rgba(158, 19, 23, 0.1);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(158, 19, 23, 0.1);
  border-color: rgba(158, 19, 23, 0.2);
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(
    135deg,
    rgba(158, 19, 23, 0.1),
    rgba(184, 28, 34, 0.05)
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9e1317;
  font-size: 1.5rem;
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 2rem;
  font-weight: 800;
  color: #222222;
  margin-bottom: 5px;
}

.stat-number span {
  font-size: 1.2rem;
  color: #9e1317;
  margin-left: 2px;
}

.stat-label {
  font-size: 0.9rem;
  color: #666666;
}

.group-business-scope {
  padding-top: 30px;
  border-top: 1px solid rgba(158, 19, 23, 0.1);
}

.group-business-scope h3 {
  font-size: 1.4rem;
  color: #222222;
  margin-bottom: 20px;
  text-align: center;
}

.business-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.business-tags .business-tag {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid rgba(158, 19, 23, 0.2);
  transition: all 0.3s ease;
}

.business-tags .business-tag:hover {
  background: rgba(158, 19, 23, 0.12);
  transform: translateY(-2px);
}

.food-business-section {
  margin-bottom: 80px;
}

.section-intro {
  text-align: center;
  margin-bottom: 50px;
}

.section-intro h2 {
  font-size: 2.5rem;
  color: #222222;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-intro h2::after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 3px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  border-radius: 2px;
}

.section-subtitle {
  color: #666666;
  font-size: 1.1rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.section-description {
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.1rem;
  line-height: 1.7;
  color: #444444;
}

.business-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  position: relative;
}

.business-layout::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(158, 19, 23, 0.3),
    rgba(158, 19, 23, 0.1)
  );
}

.business-column {
  height: 100%;
}

.company-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  height: 100%;
  border: 2px solid rgba(158, 19, 23, 0.15);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.company-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(158, 19, 23, 0.15);
  border-color: rgba(158, 19, 23, 0.3);
}

.company-header {
  background: linear-gradient(
    135deg,
    rgba(158, 19, 23, 0.08),
    rgba(184, 28, 34, 0.04)
  );
  padding: 30px;
  border-bottom: 1px solid rgba(158, 19, 23, 0.1);
}

.company-header {
  display: flex;
  align-items: center;
  gap: 20px;
}

.company-logo {
  width: 70px;
  height: 70px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.8rem;
  flex-shrink: 0;
}

.company-title h3 {
  font-size: 1.6rem;
  color: #222222;
  margin-bottom: 8px;
}

.company-subtitle {
  color: #9e1317;
  font-size: 1.1rem;
  font-weight: 600;
}

.company-content {
  padding: 30px;
}

.company-intro p {
  font-size: 1rem;
  line-height: 1.7;
  color: #444444;
  margin-bottom: 25px;
  text-align: justify;
}

.brand-highlight {
  background: rgba(158, 19, 23, 0.04);
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 25px;
  border-left: 4px solid #9e1317;
}

.brand-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.brand-highlight h4 {
  font-size: 1.3rem;
  color: #222222;
  margin-bottom: 15px;
}

.brand-desc {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #444444;
}

.achievement-stats {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin: 25px 0;
}

.achievement-item {
  background: white;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  border: 2px solid rgba(158, 19, 23, 0.1);
}

.achievement-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(
    135deg,
    rgba(158, 19, 23, 0.1),
    rgba(184, 28, 34, 0.05)
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9e1317;
  font-size: 1.2rem;
}

.achievement-content {
  flex: 1;
}

.achievement-value {
  font-size: 1.8rem;
  font-weight: 800;
  color: #222222;
  margin-bottom: 5px;
}

.achievement-value span {
  font-size: 1.2rem;
  color: #9e1317;
}

.achievement-label {
  font-size: 0.9rem;
  color: #666666;
}

.marketing-strategy h5 {
  font-size: 1.1rem;
  color: #222222;
  margin-bottom: 15px;
}

.strategy-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.strategy-tags .strategy-tag {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  border: 1px solid rgba(158, 19, 23, 0.2);
}

.project-highlight {
  background: rgba(158, 19, 23, 0.04);
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 25px;
  border-left: 4px solid #b81c22;
}

.project-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #b81c22, #d12528);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.project-highlight h4 {
  font-size: 1.3rem;
  color: #222222;
  margin-bottom: 20px;
}

.project-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.detail-item {
  background: white;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid rgba(158, 19, 23, 0.1);
}

.detail-icon {
  width: 40px;
  height: 40px;
  background: rgba(158, 19, 23, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9e1317;
  font-size: 1rem;
}

.detail-content {
  flex: 1;
}

.detail-label {
  font-size: 0.8rem;
  color: #666666;
  margin-bottom: 5px;
}

.detail-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #222222;
}

.advantage-analysis h5 {
  font-size: 1.1rem;
  color: #222222;
  margin-bottom: 15px;
}

.advantage-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.advantage-list li {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #444444;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.advantage-list li i {
  color: #9e1317;
  margin-top: 3px;
  flex-shrink: 0;
}

.business-areas {
  margin-bottom: 80px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #222222;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-header h2::after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 3px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  border-radius: 2px;
}

.section-subtitle {
  color: #666666;
  font-size: 1.1rem;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.business-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 35px 30px;
  border: 1px solid #e0e0e0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.business-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  transform: scaleX(0);
  transition: transform 0.4s;
}

.business-card.hovered::before {
  transform: scaleX(1);
}

.business-card:hover {
  background: rgba(158, 19, 23, 0.04);
  border-color: rgba(158, 19, 23, 0.3);
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(158, 19, 23, 0.12);
}

.business-icon-container {
  margin-bottom: 25px;
}

.business-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 1.8rem;
  border: 2px solid;
  transition: all 0.4s;
  color: #9e1317;
}

.business-card:hover .business-icon {
  transform: scale(1.1);
  box-shadow: 0 10px 20px rgba(158, 19, 23, 0.15);
}

.business-card h3 {
  font-size: 1.5rem;
  color: #222222;
  margin-bottom: 10px;
  text-align: center;
  font-weight: 600;
}

.business-subtitle {
  color: #666666;
  text-align: center;
  font-size: 0.95rem;
  margin-bottom: 25px;
  font-style: italic;
}

.business-details {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.business-details li {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #444444;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.business-details li i {
  color: #9e1317;
  margin-top: 5px;
  flex-shrink: 0;
}

.business-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.business-tag {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  border: 1px solid rgba(158, 19, 23, 0.2);
}

.industry-advantages {
  margin-bottom: 80px;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.advantage-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 35px 30px;
  text-align: center;
  border: 1px solid #e0e0e0;
  transition: all 0.4s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.advantage-card:hover {
  background: rgba(158, 19, 23, 0.03);
  border-color: rgba(158, 19, 23, 0.3);
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(158, 19, 23, 0.1);
}

.advantage-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  font-size: 2rem;
  color: #9e1317;
}

.advantage-card h3 {
  font-size: 1.4rem;
  color: #222222;
  margin-bottom: 15px;
}

.advantage-card p {
  font-size: 0.95rem;
  color: #444444;
  line-height: 1.6;
  margin-bottom: 25px;
}

.advantage-stats {
  display: flex;
  justify-content: center;
  gap: 25px;
}

.advantage-stat {
  text-align: center;
}

.stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #9e1317;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.85rem;
  color: #666666;
}

.future-vision {
  background: linear-gradient(
    135deg,
    rgba(158, 19, 23, 0.05),
    rgba(158, 19, 23, 0.01)
  );
  border-radius: 25px;
  padding: 60px;
  border: 2px solid rgba(158, 19, 23, 0.15);
}

.vision-container {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.vision-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  font-size: 2.5rem;
  color: white;
  position: relative;
  box-shadow: 0 15px 30px rgba(158, 19, 23, 0.2);
}

.vision-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background: inherit;
  animation: glow 2s infinite;
  opacity: 0.5;
}

@keyframes glow {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.3;
  }
}

.vision-content h2 {
  font-size: 2.2rem;
  color: #222222;
  margin-bottom: 20px;
}

.vision-content p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444444;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.vision-roadmap {
  max-width: 600px;
  margin: 0 auto;
}

.roadmap-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 25px;
  text-align: left;
  background: rgba(158, 19, 23, 0.03);
  padding: 20px;
  border-radius: 15px;
  border-left: 3px solid #9e1317;
  transition: all 0.3s;
}

.roadmap-item:hover {
  background: rgba(158, 19, 23, 0.06);
  transform: translateX(10px);
}

.roadmap-number {
  width: 40px;
  height: 40px;
  background: rgba(158, 19, 23, 0.12);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  color: #9e1317;
  flex-shrink: 0;
}

.roadmap-content h4 {
  font-size: 1.2rem;
  color: #222222;
  margin-bottom: 8px;
}

.roadmap-content p {
  font-size: 0.95rem;
  color: #444444;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 1200px) {
  .business-grid,
  .advantages-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .group-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .business-grid,
  .advantages-grid {
    grid-template-columns: 1fr;
  }

  .business-layout {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .business-layout::before {
    display: none;
  }

  .achievement-stats,
  .project-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-title-section {
    padding: 120px 20px 80px;
  }

  .page-title {
    font-size: 2.8rem;
  }

  .company-detail {
    padding: 60px 20px;
  }

  .group-overview {
    padding: 30px;
  }

  .group-header {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .group-stats {
    grid-template-columns: 1fr;
  }

  .company-header {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .business-tags {
    justify-content: flex-start;
  }

  .future-vision {
    padding: 40px 20px;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 2.2rem;
  }

  .page-title-icon {
    width: 80px;
    height: 80px;
    font-size: 2.5rem;
  }

  .company-detail {
    padding: 40px 15px;
  }

  .group-overview {
    padding: 20px;
  }

  .group-title h2 {
    font-size: 1.8rem;
  }

  .section-intro h2,
  .section-header h2 {
    font-size: 2rem;
  }

  .company-card {
    margin: 0 -15px;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}
</style>
